import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Grid, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Business, LocalHospital, Assignment, Download } from '@mui/icons-material';

const MainProjects = ({ productId }) => {
  const { t, i18n } = useTranslation();
  const [modules, setModules] = useState(null);

  useEffect(() => {
    async function loadModules() {
      try {
        const file = await import(`../data/product${productId}-modules.json`);
        setModules(file.default || file);
      } catch (err) {
        setModules(null);
      }
    }
    if (productId) {
      loadModules();
    }
  }, [productId]);



  console.log(modules, "file")
  const projects = [
    {
      id: 1,
      title:
        (modules && t(`productModules.product${modules?.productId || productId}.features.0.title`)) ||
        (modules && modules.features[0] && modules.features[0].title),
      description:
        (modules && t(`productModules.product${modules?.productId || productId}.features.0.explanation`)) ||
        (modules && modules.features[0] && modules.features[0].explanation),
      icon: Business,
      image: modules&& modules.features[0] && modules.features[0].image,
      imagePosition: 'right', // text left, image right
    },
    {
      id: 2,
      title:
        (modules && t(`productModules.product${modules?.productId || productId}.features.1.title`)) ||
        (modules && modules.features[1] && modules.features[1].title),
      description:
        (modules && t(`productModules.product${modules?.productId || productId}.features.1.explanation`)) ||
        (modules && modules.features[1] && modules.features[1].explanation),
      icon: LocalHospital,
      image: modules&& modules.features[1] && modules.features[1].image,
      imagePosition: 'left', // image left, text right
    },
    {
      id: 3,
      title:
        (modules && t(`productModules.product${modules?.productId || productId}.features.2.title`)) ||
        (modules && modules.features[2] && modules.features[2].title),
      description:
        (modules && t(`productModules.product${modules?.productId || productId}.features.2.explanation`)) ||
        (modules && modules.features[2] && modules.features[2].explanation),
      icon: Assignment,
      image: modules&& modules.features[2] && modules.features[2].image,
      imagePosition: 'right', // text left, image right
    },
  ];

  // For demo: log loaded modules for debugging
  useEffect(() => {
    if (modules) {
      console.log('Loaded product modules:', modules);
    }
  }, [modules]);

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: (theme) =>
          theme.palette.mode === 'dark' ? '#0f172a' : '#f8f9fa',
      }}
    >
      <Container maxWidth="lg">


        <Box sx={{ mb: 10 }}>
          {projects.map((project, index) => {
            const isSecond = index === 1;
            const isArabic = i18n.language && i18n.language.startsWith('ar');
            const isLastItem = index === projects.length - 1;
            const isImageRight = project.imagePosition === 'right';
            // Get image src per module
            const imgSrc = modules && modules.features && modules.features[index] && modules.features[index].image;
            return (
              <Grid
                container
                spacing={0}
                key={project.id}
                sx={{ mb: isLastItem ? 0 : { xs: 6, md: 10 } }}
              >
                {/* Text Content */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  order={{ xs: 1, md: isImageRight ? 1 : 2 }}
                >
                  <Box
                    sx={{
                      pr: { xs: 0, md: isImageRight ? 6 : 0 },
                      pl: { xs: 0, md: isImageRight ? 0 : 6 },
                      pb: { xs: 4, md: 0 },
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      height: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      id= "title"
                      sx={{
                        fontSize: { xs: '1.75rem', md: '2.25rem' },
                        fontWeight: 700,
                        mb: 3,
                        lineHeight: 1.3,
                        color: (theme) =>
                          theme.palette.mode === 'dark' ? '#fff' : '#1e293b',
                        ...(isSecond && isArabic ? { mr: '20px' } : {}),
                      }}
                    >
                      {project.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: '1rem', md: '1.125rem' },
                        lineHeight: 1.8,
                        color: (theme) =>
                          theme.palette.mode === 'dark'
                            ? 'rgba(255, 255, 255, 0.65)'
                            : 'rgba(0, 0, 0, 0.55)',
                        ...(isSecond && isArabic ? { mr: '20px' } : {}),
                      }}
                    >
                      {project.description}
                    </Typography>
                  </Box>
                </Grid>

                {/* Image Part: use the image from modules json file, fallback to nothing */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  order={{ xs: 2, md: isImageRight ? 2 : 1 }}
                >
                  <Box
                    sx={{
                      height: { xs: 300, md: 400 },
                      background: (theme) =>
                        theme.palette.mode === 'dark'
                          ? 'rgba(255, 255, 255, 0.05)'
                          : '#e5e7eb',
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    {imgSrc && (
                      <img
                        src={imgSrc}
                        alt={project.title}
                        style={{
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'contain',
                          borderRadius: 6,
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
            );
          })}
          {/* Optional: display features loaded from the modules file */}
          {modules && modules.features && (
            <Box mt={6}>
              <Typography variant="h4" sx={{ mb: 2 }}>
                {t('productModules.featuresForProduct')}
              </Typography>
              <ul>
                {modules.features.map((f, i) => (
                  <li key={i}>{t(`productModules.product${modules?.productId || productId}.features.${i}.title`) || f.title || f.name}</li>
                ))}
              </ul>
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default MainProjects;

